import api from "./index"

export const routeLogCheck = async (payload, token, user) => {
  try {
    const { contract, event, } = payload
    const data = {
        systemUserId: user?.id,
        eventId: event?.value,
        opportunityId: contract?.value,
    }

    const response = await api.post("/route-log/check", data, {
        headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
        },
    });
  } catch (error) {
    console.error("Error in routeLogCheck:", error);
    throw error;
  }
}